import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './Profile.module.scss';
import { useMsal } from '@azure/msal-react';
import { ProfileTabs, ProfileTab } from '../../../Components/ProfileTabs';
import loadingGif from '../../../Assets/Animations/loading.gif';
import { userApi } from '../../../Utils/API';
import ApiSecretKey from './ApiSecretKey';
import AuditHistory from './AuditHistory';
import useLogout from '../../../hooks/useLogout';

const Profile = () => {
    const { accounts } = useMsal();
    const location = useLocation();
    const logout = useLogout();
    const navigate = useNavigate();
    const user = accounts[0] || {};
    const [profileData, setProfileData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const token_type = localStorage.getItem('token_type');
                const access_token = localStorage.getItem('access_token');

                if (!token_type || !access_token) {
                    throw new Error('Authorization token not found.');
                }

                const response = await userApi.get('/api/my-profile/', {
                    headers: {
                        Authorization: `${token_type} ${access_token}`,
                    },
                });
                setProfileData(response.data);
            } catch (err) {
                if (err.response?.status === 401) {
                    logout();
                } else {
                    console.error("Failed to fetch profile data.", err);
                    setError(err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    const displayData = {
        ...profileData,
        username: profileData.resellerCode || profileData.username,
        fullName: profileData.resellerName || profileData.fullName,
    };
    
    const renderTabContent = () => {
        const currentPath = location.pathname;
        if (currentPath.endsWith('secret-key-audit-history')) {
            return <AuditHistory />;
        }
        // Default to ApiSecretKey
        return <ApiSecretKey profileData={displayData} />;
    };

    return (
        <div className={styles.profilePage}>
            <div className={styles.profileGrid}>
                <div className={styles.leftPanel}>
                    <div className={styles.profileAvatar}>
                        <span>{localStorage.getItem("profile_initial_credential") ? localStorage.getItem("profile_initial_credential") : user.name?.split(' ').map(n => n[0]).join('')}</span>
                    </div>
                    <h2 className={styles.profileName}>{displayData.fullName}</h2>
                    <p className={styles.profileEmail}>{displayData.email}<i className={`material-icons ${styles.editIcon}`} onClick={() => navigate('/support-ticket')}>edit</i></p>
                    <button onClick={() => navigate('/support-ticket')} className={`${styles.editButton} ${styles.supportButton}`}>Create Support Ticket</button>
                </div>

                <div className={styles.rightPanel}>
                    <div className={styles.profileCard}>
                        <div className={styles.header}>
                            <h3>Profile</h3>
                        </div>
                        <ProfileTabs basepath="/profile/">
                            {/* <ProfileTab label="My Profile" to="my-profile" /> */}
                            <ProfileTab label="API Secret Key Details" to="api-secret-details" />
                            <ProfileTab label="API Secret Key Audit History" to="secret-key-audit-history" />
                        </ProfileTabs>
                        <div className={styles.tabContent}>
                            {loading ? (
                                <div className={styles.loadingContainer}>
                                    <img src={loadingGif} alt="Loading..." />
                                </div>
                            ) : (
                                renderTabContent()
                           )}
                           {location.pathname.endsWith('api-secret-details') && (
                               <div className={styles.regenerateButtonContainer}>
                                   <button onClick={() => navigate('/support-ticket')}  className={styles.regenerateButton}>Regenerate Secret Key</button>
                               </div>
                           )}
                       </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;